import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldX, Home, ArrowLeft } from "lucide-react";

const Unauthorized = () => {
    const navigate = useNavigate();
    
    const getWhatsAppLink = () => {
        const phoneNumber = "447756668272";
        const message = encodeURIComponent("Hi Krasi, I have an authorization problem on your SPL site");
        return `https://wa.me/${phoneNumber}?text=${message}`;
    };
    
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
            <div className="w-full max-w-lg px-8 py-12 text-center">
                {/* Icon */}
                <div className="mb-8 animate-bounce">
                    <ShieldX className="mx-auto h-20 w-20 text-red-500" />
                </div>
                
                {/* Error Code */}
                <h1 className="text-8xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600 mb-4">
                    403
                </h1>
                
                {/* Main Message */}
                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                    Access Denied
                </h2>
                
                {/* Description */}
                <p className="text-lg text-gray-600 mb-8">
                    Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is an error.
                </p>
                
                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => navigate("/dashboard")}
                        className="inline-flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 font-semibold rounded-lg shadow-sm hover:bg-gray-200 transition-colors duration-200"
                    >
                        <ArrowLeft className="w-5 h-5 mr-2" />
                        Go Back
                    </button>
                    
                    <button
                        onClick={() => navigate("/dashboard")}
                        className="inline-flex items-center justify-center px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition-colors duration-200"
                    >
                        <Home className="w-5 h-5 mr-2" />
                        Go to Dashboard
                    </button>
                </div>
            </div>
            
            {/* Footer with WhatsApp Link */}
            <div className="absolute bottom-8 text-sm text-gray-500">
                Need help? {" "}
                <a 
                    href={getWhatsAppLink()} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-green-600 hover:underline hover:text-green-700"
                >
                    Contact Support via WhatsApp
                </a>
            </div>
        </div>
    );
};

export default Unauthorized;